/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Castiel Zhang
 * Created: 13/10/23
 */

import React from 'react';
import CreateFutureWorkplanButton from '@/components/FutureWorkplan/CreateFutureWorkplanButton';
import DownloadWorkplanButton from '@/components/Header/DownloadWorkplanButton';
import { isWorkplanReadonly } from '@/utils/isWorkplanReadonly';
import useWorkplanVersion from '@/components/contexts/VersionContext/useWorkplanVersion';
import { Workplan } from '@/wpt-lib/interfaces/Workplan';
import useNavigateOptions from '@/components/contexts/NaviateContext/useNavigateOptions';
import CopyWorkplan from '@/components/CopyWorkplan/CopyWorkplan';
import DeleteWorkplan from '@/components/DeleteWorkplan/DeleteWorkplan';

interface WorkplanActionProps {
    workplan: Workplan;
}

export const WorkplanActions = ({ workplan }: WorkplanActionProps) => {
    const { version, current } = useWorkplanVersion();

    const { supervisor, admin } = useNavigateOptions();
    const academic = !supervisor && !admin;

    return (
        <>
            {academic && <CreateFutureWorkplanButton />}
            {academic && <CopyWorkplan workplan={workplan} />}
            {academic && current && workplan.currentVersion.version === 1 && !isWorkplanReadonly(workplan, false) && (
                <DeleteWorkplan workplan={workplan} />
            )}
            <DownloadWorkplanButton workplan={workplan} version={version} />
        </>
    );
};
